import { styled } from '@mui/material'
import Paper from '@mui/material/Paper'
import { Button } from '../../components'

export const PageContainer = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100vh;
  align-items: center;
  justify-content: center;
`

export const TOUWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 2rem;
  overflow: hidden;
  max-width: 90%;
  width: 950px;
`

export const ContentPaper = styled(Paper)`
  flex: 1;
  margin-bottom: 2rem;
  white-space: pre-wrap;
  background-color: #f9f9f9;
`

export const ActionsContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
`

export const AcceptButton = styled(Button)`
  min-width: 120px;
`
